module.exports = __webpack_public_path__ + "static/media/comunidade-elite.d77f0940.png";